import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Base',
  },
  {
    path: 'Buttons',
    breadcrumbName: 'Buttons',
  },
];

const Buttons = () => {
  return (
    <>
      <PageHeader title="Button-color" breadcrumb={{ routes }} subTitle="Buttons" style={{ padding: 10 }} />

      <div className="MF_area">
        <button type="submit" className="btn">btn</button>&nbsp;
        <button type="submit" className="btn btn_lightgray">btn_lightgray</button>&nbsp;
        <button type="submit" className="btn btn_gray">btn_gray</button>&nbsp;
        <button type="submit" className="btn btn_blue">btn_blue</button>&nbsp;
        <button type="submit" className="btn btn_green">btn_green</button>&nbsp;
        <button type="submit" className="btn btn_skyblue">btn_skyblue</button>&nbsp;
        <button type="submit" className="btn btn_orange">btn_orange</button>&nbsp;
        <button type="submit" className="btn btn_red">btn_red</button>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<button type="submit" class="btn">btn</button>
<button type="submit" class="btn btn_lightgray">btn_lightgray</button>
<button type="submit" class="btn btn_gray">btn_gray</button>
<button type="submit" class="btn btn_blue">btn_blue</button>
<button type="submit" class="btn btn_green">btn_green</button>
<button type="submit" class="btn btn_skyblue">btn_skyblue</button>
<button type="submit" class="btn btn_orange">btn_orange</button>
<button type="submit" class="btn btn_red">btn_red</button>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


      <PageHeader title="Button-fill" breadcrumb={{ routes }} subTitle="Buttons" style={{ padding: 10 }} />

      <div className="MF_area">
        <button type="submit" className="btn btn_fill_gray">btn_fill_gray</button>&nbsp;
        <button type="submit" className="btn btn_fill_blue">btn_fill_blue</button>&nbsp;
        <button type="submit" className="btn btn_fill_bluegray">btn_fill_bluegray</button>&nbsp;
        <button type="submit" className="btn btn_fill_bluegray_dark">btn_fill_bluegray_dark</button>&nbsp;
        <button type="submit" className="btn btn_fill_green">btn_fill_green</button>&nbsp;
        <button type="submit" className="btn btn_fill_skyblue">btn_fill_skyblue</button>&nbsp;
        <button type="submit" className="btn btn_fill_orange">btn_fill_orange</button>&nbsp;
        <button type="submit" className="btn btn_fill_red">btn_fill_red</button>&nbsp;
        <button type="submit" className="btn btn_fill_brown">btn_fill_brown</button>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<button type="submit" class="btn btn_fill_gray">btn_fill_gray</button>
<button type="submit" class="btn btn_fill_blue">btn_fill_blue</button>
<button type="submit" class="btn btn_fill_green">btn_fill_green</button>
<button type="submit" class="btn btn_fill_skyblue">btn_fill_skyblue</button>
<button type="submit" class="btn btn_fill_orange">btn_fill_orange</button>
<button type="submit" class="btn btn_fill_red">btn_fill_red</button>
<button type="submit" class="btn btn_fill_brown">btn_fill_brown</button>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <PageHeader title="Button-disabled" breadcrumb={{ routes }} subTitle="Buttons" style={{ padding: 10 }} />

      <div className="MF_area">
        <button type="submit" className="btn btn_fill_gray" disabled>btn_fill_gray</button>&nbsp;
        <button type="submit" className="btn btn_fill_blue" disabled>btn_fill_blue</button>&nbsp;
        <button type="submit" className="btn btn_fill_bluegray" disabled>btn_fill_bluegray</button>&nbsp;
        <button type="submit" className="btn btn_fill_bluegray_dark" disabled>btn_fill_bluegray_dark</button>&nbsp;
        <button type="submit" className="btn btn_fill_green" disabled>btn_fill_green</button>&nbsp;
        <button type="submit" className="btn btn_fill_skyblue" disabled>btn_fill_skyblue</button>&nbsp;
        <button type="submit" className="btn btn_fill_orange" disabled>btn_fill_orange</button>&nbsp;
        <button type="submit" className="btn btn_fill_red" disabled>btn_fill_red</button>&nbsp;
        <button type="submit" className="btn btn_fill_brown" disabled>btn_fill_brown</button>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<button type="submit" class="btn btn_fill_gray" disabled>btn_fill_gray</button>
<button type="submit" class="btn btn_fill_blue" disabled>btn_fill_blue</button>
<button type="submit" class="btn btn_fill_bluegray" disabled>btn_fill_bluegray</button>
<button type="submit" class="btn btn_fill_bluegray_dark" disabled>btn_fill_bluegray_dark</button>
<button type="submit" class="btn btn_fill_green" disabled>btn_fill_green</button>
<button type="submit" class="btn btn_fill_skyblue" disabled>btn_fill_skyblue</button>
<button type="submit" class="btn btn_fill_orange" disabled>btn_fill_orange</button>
<button type="submit" class="btn btn_fill_red" disabled>btn_fill_red</button>
<button type="submit" class="btn btn_fill_brown" disabled>btn_fill_brown</button>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

      <PageHeader title="Buttons-size" breadcrumb={{ routes }} subTitle="Buttons" style={{ padding: 10 }} />

      <div className="MF_area">
        <button type="submit" className="btn btn_lg v_top">btn_lg</button>&nbsp;
        <button type="submit" className="btn btn_lg btn_fixed v_top">btn_lg_fixed</button>&nbsp;
        <button type="submit" className="btn v_top">btn_md</button>&nbsp;
        <button type="submit" className="btn btn_fixed v_top">btn_md_fixed</button>&nbsp;
        <button type="submit" className="btn btn_sm v_top">btn_sm</button>&nbsp;
        <button type="submit" className="btn btn_sm btn_fixed v_top">btn_sm_fixed</button>&nbsp;
        <button type="submit" className="btn btn_xs v_top">btn_xs</button>&nbsp;
        <button type="submit" className="btn btn_xs btn_fixed v_top">btn_xs_fixed</button>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<button type="submit" class="btn btn_lg">btn_lg</button>
<button type="submit" class="btn">btn_md</button>
<button type="submit" class="btn btn_sm">btn_sm</button>
<button type="submit" class="btn btn_xs">btn_xs</button>
<button type="submit" class="btn btn_xs btn_fixed">btn_fixed</button>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default Buttons;
